import React from 'react';
import { Svg, Path } from "react-native-svg-web";


const StarstruckFace = ({
  style,
  className,
  size = '30px',
  color = '#333' }) => /*#__PURE__*/

React.createElement(Svg, {
  fill: "none",
  width: size,
  height: size,
  style: style,
  viewBox: "0 0 30 31",
  className: className,
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement(Path, {
  d: "M19.8292 21.0576C20.8206 20.0071 21.3066 18.8242 21.4612 18.2057L18.9388 17.5751C18.8768 17.8232 18.5827 18.5903 17.9383 19.2731C17.3289 19.9189 16.4114 20.4904 15 20.4904C13.5886 20.4904 12.6712 19.9189 12.0617 19.2731C11.4173 18.5903 11.1232 17.8232 11.0612 17.5751L8.53883 18.2057C8.69346 18.8242 9.1794 20.0071 10.1708 21.0576C11.1972 22.1452 12.7714 23.0904 15 23.0904C17.2286 23.0904 18.8028 22.1452 19.8292 21.0576Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  d: "M14.0345 11.9231L11.6521 11.6091L10.6173 9.44037L9.58238 11.6091L7.2 11.9231L8.9428 13.5775L8.50527 15.9404L10.6173 14.7941L12.7292 15.9404L12.2917 13.5775L14.0345 11.9231Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  d: "M23.1345 11.9231L20.7521 11.6091L19.7173 9.44037L18.6824 11.6091L16.3 11.9231L18.0428 13.5775L17.6053 15.9404L19.7173 14.7941L21.8292 15.9404L21.3917 13.5775L23.1345 11.9231Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  d: "M28 15.9404C28 8.76067 22.1797 2.94037 15 2.94037C7.8203 2.94037 2 8.76067 2 15.9404C2 23.1201 7.8203 28.9404 15 28.9404C22.1797 28.9404 28 23.1201 28 15.9404ZM15 5.54037C20.7438 5.54037 25.4 10.1966 25.4 15.9404C25.4 21.6841 20.7438 26.3404 15 26.3404C9.25624 26.3404 4.6 21.6841 4.6 15.9404C4.6 10.1966 9.25624 5.54037 15 5.54037Z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: color }));




export default StarstruckFace;